var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":12}},[(_vm.loading)?_c('LoaderWidget'):(_vm.coverageData.length > 0)?_c('div',{style:({ height: _vm.height + 'px' })},[_c('v-chart',{attrs:{"option":_vm.option,"autoresize":""},on:{"click":_vm.onClick}})],1):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }